import React from 'react';
import InfoBox from 'react-google-maps/lib/components/addons/InfoBox';
import i18next from 'i18next';

import { ROUTES } from '~constants/routes';
import StageProgress from '~components/StageProgress';
import closeIcon from '~assets/ic_general_close_radio_blue.svg';
import { TYPES } from '~constants/content';
import ContentType from '~components/ContentType';
import Flags from '../Flags';

import styles from './styles.module.scss';

interface Props {
  id: number;
  title: string;
  stageOrder: number;
  onClose: (event: React.MouseEvent) => void;
  themes: {
    id: number;
    name: string;
  }[];
  countries: string;
}

/* eslint-disable react/jsx-max-depth */
function ProjectPopup(props: Props) {
  const { id, title, stageOrder, onClose, themes, countries } = props;
  const to = ROUTES.IIRSA_PROJECT_DETAIL.replace(':id', encodeURIComponent(id.toString()));

  return (
    <InfoBox
      defaultOptions={{ closeBoxURL: '', enableEventPropagation: true, boxStyle: { overflow: 'visible' } }}
    >
      <div className={styles.container}>
        <div className={`full-width ${styles.bubbleAnchor}`}>
          <div className={styles.bubble}>
            <div className={styles.box}>
              
                <div className={`column ${styles.info}`}>
                  <div className={styles.header}>
                    {themes.map(theme => (
                      <ContentType key={theme.id} type={TYPES.project} infrastructure={theme} compact dark />
                    ))}
                    <button type="button" onClick={onClose} className={styles.closeButton}>
                      <img
                        alt={i18next.t('projectPopup:close').toString()}
                        src={closeIcon}
                        className={styles.closeImage}
                      />
                    </button>
                  </div>
                  <a target="_blank" href={to}>
                    <span className={`text-xsmall bold ${styles.title}`}>{title}</span>
                  </a>
                  <Flags countries={countries.split(',').map(country => country.trim())}/>
                  <StageProgress order={stageOrder} size="sm" className={styles.progressContainer}/>
                </div>
              
            </div>
          </div>
        </div>
      </div>
    </InfoBox>
  );
}
/* eslint-enable react/jsx-max-depth */

export default ProjectPopup;
